import { enumParser } from '#validation/common/parsers';
import { UserSsoState } from '../constants';
export const userSsoStateParser = enumParser(UserSsoState);
